import {CARD} from "./card";
import {GTM} from "./gtm";
import Cookies from 'js-cookie';
import {CRYPTO} from "./crypto";

export const B2B = {

    base64ToFile: function(base64, fileName, mimeType) {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new File([byteArray], fileName, { type: mimeType });
    },

    getCred: async function() {
        return await CARD.postData({}, '/u/cred');
    },

    novaposhtaGetApiKey: async function() {
        return new Promise(async (res, rej) => {
            let result = null;
            const key = await localStorage.getItem('novaposhta_api_key');

            if (key) {
                const cred = await this.getCred();
                const result = await CRYPTO.decrypt(key, cred.iv, cred.salt);
                // console.log('Decrypt: ', result);

                if (result.length > 0) {
                    res(result);
                } else {
                    rej();
                }


            } else {
                rej();
            }
        });

    },

    novaposhtaSetApiKey: async function(key) {
        const cred = await this.getCred();
        const encrypted = await CRYPTO.encrypt(key, cred.iv, cred.salt);
        localStorage.setItem('novaposhta_api_key', encrypted);
        // console.log(encrypted);
        return;
    },

    cart_open_hook: function() {
        if (G.b2b_cart==0) {
            $(".cart__bottom").remove();
            $(".cart__items").remove();
            $(".cart__empty").remove();
            $(".cart").addClass('cart-tech');
            $(".cart__content").append('<div class="cart__empty cart__empty-tech"><h2>Кошик не працює</h2><p class="mb16">Проводяться технічні роботи</p><button class="btn js-cart__close">Закрити</button></div>')
        }
    },

    make_order: function(form){
        CARD.onorderpage = true;

        if (!CARD.count_items) {
            form.find('.alert').removeClass('hidden').html('Перевірте вміст корзини');
            return;
        }

        $(".firedContainer").addClass('hidden');
        let delivery = form.serializeObject();

        const formData = new FormData(form[0]);

        formData.append('action', 'basket');
        formData.append('to', 'order');
        formData.append('locale', G.locale_id);
        formData.append('count_items', CARD.count_items);
        formData.append('sum[uah]', CARD.sum.uah);
        formData.append('sum[usd]', CARD.sum.usd);
        formData.append('page', document.location.pathname);

        let paymentMethod = $.trim($(".make-b2b-payment.active").text());
        let deliveryMethod = $.trim($(".cart .make-b2b-carrier.active").text());
        let _deliveryMethod = $("[name=carrier]", form).val();

        $.ajax({
            url: "/aj",
            type: "POST",
            data: formData,
            processData: false,        // обов'язково!
            contentType: false,        // обов'язково!
            timeout: 40000, // in milliseconds
            success: (data) => {
                data = JSON.parse(data);

                if (!data.success) {
                    form.find('.alert').removeClass('hidden').html(data.error);
                    form.find('[type=submit]').html('Підтвердити').removeClass('loading');
                    CARD.onorderpage = false;
                    CARD.updatePromise();
                    return;
                }

                if (data.payment_problem) {
                    form.find('.alert').removeClass('hidden').html(data.error);
                    CARD.onorderpage = false;
                    return;
                }

                GTM.event('checkout_step', 3, 'Доставка', deliveryMethod);
                GTM.event('checkout_step', 4, paymentMethod);
                GTM.event('purchase', data.order, data.products);

                CARD.window(data.step ? '' : 'process-thx', data.html);
                $(".cart .checkout").addClass('thx');
                $(".cart .bottom").append('<button class="close-cart" type="button">Закрити</button>');
                CARD.firstopened = false;
                CARD.set_card_count(0);
                return false;
            },
            error: function(request, status, err) {
                form.find('[type=submit]').html('Підтвердити').removeClass('loading');
                form.find('.alert').removeClass('hidden').html(`Щось пішло не так. Спробуйде відправити Ваше замовлення ще раз. Lead ${CARD.lead_id}`);
                CARD.onorderpage = false;
            }
        });
    },

    submitform: function(btn){

        let form = btn.parents('form');
        let possible = this.submit_active(true);

        if (!possible || btn.hasClass('loading')) {
            return false;
        } else {
            btn.addClass('loading');
            this.make_order(form);
        }
    },

    open_checkout_hook: function(data) {
        CARD.window('process-checkout', data.window);
        $(".cart select[name=contractor]").select2({minimumResultsForSearch: Infinity});
        B2B.make_file_inputs();
    },

    submit_active: function(show_errors) {
        let active = 0;
        let errors = [];

        if (!($(".cart [name=delivery]").val()==''))
            active++;
        else {
            errors.push('Оберіть варіант оформлення замовлення');
        }

        // payment
        let method = $(".cart [name=payment]").val();
        let carrier = $(".cart [name=carrier]").val();

        if (!(method=='')) {
            if (method == 'cashless') {
                if ($(".cart [name=contractor]").length > 0 && !($(".cart [name=contractor]").val() == '')) {
                    active++;
                } else {
                    errors.push('Оберіть юридичну особу');
                }
            } else
                active++;
        }

        if ($(".cart .make-b2b-carrier.active").length > 0) {
            if ($(".cart .make-b2b-carrier.active").hasClass('default-val')) {
                // выбор склада
                if (!($(".cart [name=store] option:selected").val()=='')) {
                    active++;
                }
                else {
                    errors.push('Склад не обраний');
                }
            } else {
                switch(carrier) {
                    case 'dropshipping':
                        const ttn = $(".cart [name=ttn]").val();
                        const express = $(".cart input[name=express]");
                        const zebra = $(".cart input[name=zebra]");

                        if (ttn.length < 8) {
                            errors.push('Вкажіть ТТН для кліента');
                        }

                        if (!(express.val() && express.data('ext').toLowerCase()=='pdf')) {
                            errors.push('Додайте експрес-накладну в форматі PDF');
                        }

                        if (!(zebra.val() && zebra.data('ext').toLowerCase()=='pdf')) {
                            errors.push('Додайте маркування в форматі PDF');
                        }

                        break;

                    default:
                        active++;
                        break;
                }
            }
        } else {
            errors.push('Оберіть метод доставки');
        }

        if (CARD.sum.usd > 0 || CARD.sum.uah > 0) {
            active++;
        }

        if (show_errors && errors.length > 0)
            $(".cart .checkout form .alert-submit").removeClass('hidden').html(errors.join('<br />'));
        else
            $(".cart .checkout form .alert-submit").addClass('hidden')

        return errors.length==0;
    },

    make_file_inputs: function() {

        const inputs = document.querySelectorAll( '.inputfile' );
        Array.prototype.forEach.call( inputs, function( input )
        {
            let label	 = input.nextElementSibling,
                labelVal = label.innerHTML;

            input.addEventListener( 'change', function( e )
            {
                let fileName = '';
                let filesize = 0;

                if( this.files && this.files.length > 1 )
                    fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
                else
                    fileName = e.target.value.split( '\\' ).pop();

                console.log(this.files);

                if (this.files) {
                    filesize = this.files[0].size;
                    const sizeInKb = (filesize / (1024)).toFixed(2);
                    const fileExt = this.files[0].name.split('.').pop();

                    fileName = `${sizeInKb} kB (${fileExt})`;
                    $(input).data('filesize', filesize);
                    $(input).data('ext', fileExt);
                }

                if( fileName )
                    label.querySelector( 'span' ).innerHTML = fileName;
                else
                    label.innerHTML = labelVal;
            });

            // Firefox bug fix
            input.addEventListener( 'focus', function(){ input.classList.add( 'has-focus' ); });
            input.addEventListener( 'blur', function(){ input.classList.remove( 'has-focus' ); });
        });

    },

    cardHook: function(data) {
        if (data.settlements) {
            if (data.settlements > 1) {
                $(".cart .cart__bottom .settlements").remove();
                $(".cart .cart__bottom").html('<a href="/u/settlements/" class="alert alert-danger alert-settlements">Оформлення замовлення неможливе.<br />Підтвердіть Ваш баланс</a>');
            } else {
                $(".cart .cart__bottom .settlements").remove();
                $(".cart .cart__bottom").prepend('<a href="/u/settlements/" class="alert settlements">Підтвердіть Ваш баланс</a>');
            }
        }
    }
}

export function init_B2B_events(){
    jQuery(document).ready(function () {

        if (Cookies.get('slrafterlogin')) {
            GTM.event('b2bauth', Cookies.get('slrafterlogin'));
            Cookies.remove('slrafterlogin');
        }

        jQuery("body").on("click", ".cart form [type=submit]", function (e) {
            e.preventDefault();
            B2B.submitform($(this));
        });

        jQuery("body").on("submit", ".settlements-form", function (e) {
            let btn = $(this).find('[type=submit]');

            if (btn.hasClass('disabled')) {
                e.preventDefault();
                return false;
            }

            btn.addClass('disabled').prepend('<i class="fa fa-spin fa-spinner"></i> ');
            return true;
        });

        // +
        jQuery("body").on("click", ".cart .cart__itemcount button", function (e) {
            e.preventDefault();
            let btn = $(this);
            let element = btn.parent().find('input');

            if (!btn.hasClass('load-animation')) {
                btn.addClass('load-animation');
                let c = Number(element.val());
                element.val(c);
                CARD.update_count(c, element.parents('.cart__item').data('sku'));
            }
        });

        // edit count +
        jQuery("body").on("keyup", ".cart .cart__itemcount input", function (e) {
            let input = $(this);
            let container = input.parent();
            container.find('button').removeClass('hidden');
        });

        // + Клик выбора метода доставки
        jQuery("body").on("click", ".cart .make-b2b-delivery", function (e) {
            e.preventDefault();
            e.stopPropagation();
            let btn = $(this);
            let input = btn.find('input');

            $(".make-b2b-delivery").removeClass('active');
            $(".cart [name=delivery]").val(input.val());
            btn.addClass('active');

            switch (input.val()) {
                case 'self':
                    $(".do_partial_shipping").removeClass('hidden');
                    $(".do_partial_shipping .delivery_date").addClass('hidden');
                    $(".do_partial_shipping .partial-shipping").removeClass('hidden').addClass('active');
                    $(".do_partial_shipping .partial-shipping input").prop('checked', true);
                    $(".do_partial_shipping .delivery_start_date").removeClass('hidden');
                    break;
                case 'to_manager':
                    $(".do_partial_shipping").addClass('hidden');

                    break;
                case 'reserve':
                    $(".do_partial_shipping").removeClass('hidden');
                    $(".do_partial_shipping .delivery_date").removeClass('hidden');
                    $(".do_partial_shipping .partial-shipping").addClass('hidden');
                    $(".do_partial_shipping .delivery_start_date").addClass('hidden');
                    $(".do_partial_shipping .delivery_date select").select2({minimumResultsForSearch: Infinity});
                    break;
                default:
                    break;
            }

            B2B.submit_active();
            return;
        });

        // + Клик выбора partial-shipping
        jQuery("body").on("click", ".cart .partial-shipping", function (e) {
            e.stopPropagation();
            e.preventDefault();
            let btn = $(this);

            if (btn.hasClass('opened')) {
                $(".cart [name=partial_shipping]").val(1);
                btn.removeClass('opened');
                $(".do_partial_shipping .delivery_date").addClass('hidden');
                $(".do_partial_shipping .delivery_start_date").removeClass('hidden');
            } else {
                $(".cart [name=partial_shipping]").val(0);
                btn.addClass('opened');
                $(".do_partial_shipping .delivery_date").removeClass('hidden');
                $(".do_partial_shipping .delivery_start_date").addClass('hidden');
                $(".do_partial_shipping .delivery_date select").select2({minimumResultsForSearch: Infinity});
            }

            B2B.submit_active();
        });

        // + Клик выбора метода оплаты
        jQuery("body").on("click", ".cart .make-b2b-payment", function (e) {
            e.preventDefault();
            e.stopPropagation();

            let btn = $(this);

            if (!btn.hasClass('disabled')) {
                $(".cart [name=payment]").val(btn.find('input').val());
                btn.parent().find('>a').removeClass('active');
                btn.addClass('active');
                btn.parent().find('>div').addClass('hidden');
                btn.parent().find('>div.for-' + btn.find('input').val()).removeClass('hidden');
                btn.parent().find('>div.for-' + btn.find('input').val() + ' select').select2({minimumResultsForSearch: Infinity});
                CARD.set_payment_method(btn.find('input').val());
                B2B.submit_active();
            }
            return;
        });

        // + Клик выбора make-b2b-carrier
        jQuery("body").on("click", ".cart .make-b2b-carrier", function (e) {
            e.preventDefault();
            e.stopPropagation();

            let btn = $(this);

            if (!btn.hasClass('disabled')) {

                const carrier = btn.find('input').val();
                $(".cart [name=carrier]").val(btn.find('input').val());
                btn.parent().find('>a').removeClass('active');
                btn.addClass('active');
                btn.parent().find('>div').addClass('hidden');
                btn.parent().find('>div.for-' + btn.find('input').val()).removeClass('hidden');
                btn.parent().find('>div.for-' + btn.find('input').val() + ' select').select2({minimumResultsForSearch: Infinity});

                // hook
                switch(carrier) {
                    case 'dropshipping':
                        B2B.novaposhtaGetApiKey().then(res => {
                            $(".js-dropshipping__generate").removeClass('hidden');
                            $(".dropshipping__ttn").removeClass('dropshipping__ttn-wide');
                        }).catch(() => {
                            $(".js-dropshipping__generate").addClass('hidden');
                            $(".dropshipping__ttn").addClass('dropshipping__ttn-wide');
                        });
                        break;

                    default:
                        break;
                }

                B2B.submit_active();
            }
            return;
        });

        // Выбор контрагента
        jQuery("body").on("change", ".cart [name=contractor]", function (e) {
            B2B.submit_active();
            return;
        });

        // Выбор конкретного магазина
        jQuery("body").on("change", ".cart [name=store]", function (e) {
            B2B.submit_active();
            return;
        });

        jQuery("input[name=return_type]").on("change", function () {
            let text = jQuery(this).val();
            if (text == 'Повернення розпакованого товару' || text == 'Повернення НЕрозпакованого товару') {
                $("#reason_return_wraper").removeAttr("style");

                $('option', $("#reason_return")).remove();
                $("#reason_return").append($('<option selected disabled>Вкажіть причину повернення</option>'));
                $("#reason_return").append($('<option>Акт зарахування</option>'));
                $("#reason_return").append($('<option>Некондиція, виявлена до продажу товару</option>'));
                $("#reason_return").append($('<option>Клієнт партнера відмовився від товару</option>'));
                $("#reason_return").append($('<option>Дубль замовлення</option>'));

            } else {
                $("#reason_return_wraper").removeAttr("style");

                $('option', $("#reason_return")).remove();
                $("#reason_return").append($('<option>Ремонт товару в СЦ</option>'));
            }

            if (text == 'Платний ремонт') {
                jQuery('#product_code').html('Код товару:');
                jQuery('#product_purchase_date').html('Дата продажу:');
            } else {
                jQuery('#product_code').html("Код товару:" + red_star);
                jQuery('#product_purchase_date').html("Дата продажу:" + red_star);
            }

        });

        try {
            jQuery("input[name=product_purchase_date]").mask("99.99.9999");
            jQuery("input[name=shipping_date_repair]").mask("99.99.9999");
        } catch (e) {
        }

        B2B.make_file_inputs();

        // переключение спец цен в настройках
        $(".settings-form input[name=extraprice]").change(function () {
            $(".price-settings").toggleClass('hidden');
        });

        // + загрузка баланса в xls
        jQuery("body").on("click", ".balance-load-xls", function (e) {
            e.preventDefault();
            let btn = $(this);
            console.log('/u/balancexls/?date=' + $(".sorting__item-active").data('val') + '&a=' + btn.data('a') + '&n=' + btn.data('n'));
            window.open('/u/balancexls/?date=' + $(".sorting__item-active").data('val') + '&a=' + btn.data('a') + '&n=' + btn.data('n'));
        });

        // + загрузка истории в xls
        jQuery("body").on("click", ".history-load-xls", function (e) {
            e.preventDefault();
            window.open('/u/historyxls/?date=' + $(".sorting__item-active").data('val').data('val'));
        });

        // + b2b cashless
        jQuery("body").on("click touchend", ".toggleCashless", function (e) {
            e.preventDefault();
            var btn = $(this);

            if (btn.hasClass('disabled'))
                return;

            $.post('/aj', 'action=u&to=cashless', function () {
                document.location.reload();
            }, 'json');
        });

        // open chose cart +
        jQuery("body").on("click", ".cart .change-cart", function (e) {
            e.preventDefault();

            if ($(".cart .chose-cart-container").length) {
                $(".cart .chose-cart-container").remove();
                $(".change-cart").removeClass('active');
            } else {
                $(".change-cart").addClass('active');
                $.post(
                    '/aj',
                    {
                        action: 'u',
                        to: 'chosecart',
                        locale: G.locale_id
                    },
                    function (data) {
                        $(".cart__content").append('<div class="chose-cart-container">' + data.html + '</div>');
                    },
                    'json'
                );
            }
        });

        // make new cart +
        jQuery("body").on("click", ".cart .make-new", function (e) {
            e.preventDefault();
            $.post(
                '/aj',
                {
                    action: 'u',
                    to: 'setnewcart',
                    leadid: 'newcart',
                    locale: G.locale_id
                },
                function (data) {
                    CARD.updatePromise().then(() => {
                        $(".cart .change-cart").trigger('click');
                    });
                }, 'json');
        });

        // select cart +
        jQuery("body").on("click", ".cart-list >div", function (e) {
            e.preventDefault();
            e.stopPropagation();
            let lead = $(this).data('lead');
            $.post(
                '/aj',
                {
                    action: 'u',
                    to: 'setnewcart',
                    leadid: $(this).data('lead'),
                    locale: G.locale_id
                },
                function (data) {
                    CARD.updatePromise().then(() => {
                        $(".cart .change-cart").trigger('click');
                    });
                }, 'json');
        });

        jQuery("body").on("click", ".open-goods-paste", function (e) {
            e.preventDefault();

            if ($(".cart__addgoods").length)
                $(".cart__addgoods").remove();
            else {
                $(".cart .cart__bottom").append(
                    '<div class="cart__addgoods">' +
                    '<a href="#" class="close-form"></a>' +
                    '<textarea placeholder="Введіть коди товарів, через кому" rows="5"></textarea>' +
                    '<button class="success">Додати товари в кошик</button>' +
                    '</div>'
                );

                $(".cart__addgoods").addClass('show');
            }
        });

        jQuery("body").on("click", ".cart__addgoods .close-form", function (e) {
            e.preventDefault();
            $(".cart__addgoods").remove();
        });

        jQuery("body").on("click", ".cart__addgoods button", function (e) {
            e.preventDefault();
            let btn = $(this);

            $.post(
                '/aj',
                {
                    action: 'basket',
                    to: 'addmany',
                    update: 1,
                    locale: G.locale_id,
                    sku: btn.parent().find('textarea').val(),
                },
                function (data) {
                    CARD.need_clean = 1;
                    CARD.updatePromise().then(() => {
                        CARD.hideorderform(1);
                        $(".cart__addgoods .close-form").trigger('click');
                    });
                },
                'json'
            );
        });

        jQuery("body").on("change", ".cart [name=express], .cart [name=zebra]", function (e) {
            e.preventDefault();
            let input = $(this);
            let errors = [];

            const express = $(".cart [name=express]");
            const zebra = $(".cart [name=zebra]");

            if (zebra.val() && express.val()) {
                if (zebra.data('filesize') > express.data('filesize')) {
                    errors.push('Маркування не може бути більшим розміром, ніж накладна. Перевірте чи не переплутали файли.');
                }
            }

            // buttons
            input.parents('.dropfile__container').removeClass('dropfile__container-wide');

            if (errors.length > 0) {
                $(".cart .alert-dropshipping").html(errors.join('<br />')).removeClass('hidden');
            }
        });

        jQuery("body").on("submit", ".js-settings-form", function (e) {
            e.preventDefault();
            let form = $(this);

            const formData = new FormData(form[0]);

            B2B.novaposhtaSetApiKey($("[name=novaposhta_api_key]").val()).then(() => {
                formData.delete('novaposhta_api_key');

                formData.append('action', 'u');
                formData.append('to', 'settings');

                $.ajax({
                    url: "/aj",
                    type: "POST",
                    data: formData,
                    processData: false,        // обов'язково!
                    contentType: false,        // обов'язково!
                    timeout: 40000, // in milliseconds
                    success: (data) => {
                        document.location.reload();
                    },
                    error: function(request, status, err) {
                    }
                });
            })
        });

        function showPdfInPopup(file) {
            const reader = new FileReader();
            reader.onload = function (e) {
                const base64 = e.target.result;

                // Вікно з переглядом
                const popup = window.open('', '_blank', 'width=800,height=600');
                popup.document.write(`
                    <html>
                    <head><title>${file.name}</title></head>
                    <body style="margin:0">
                      <iframe src="${base64}" width="100%" height="100%" style="border:none;"></iframe>
                    </body>
                    </html>
              `);
            };
            reader.readAsDataURL(file);
        }

        jQuery("body").on("click", ".js-dropshipping__generate", function (e) {
            e.preventDefault();
            e.stopPropagation();
            const files = $(".js-dropshipping__files");
            files.addClass('loading');

            const express = $("[name=express]", files);
            const zebra = $("[name=zebra]", files);

            return B2B.novaposhtaGetApiKey().then(apikey => {
                const formData = new FormData();

                formData.append('action', 'u');
                formData.append('to', 'loadttnfiles');
                formData.append('apikey', apikey);
                formData.append('number', $(".js-dropshipping__number").val());

                express.parents('.dropfile__container').parent().find('.alert').remove();
                zebra.parents('.dropfile__container').parent().find('.alert').remove();

                $.ajax({
                    url: "/aj",
                    type: "POST",
                    data: formData,
                    processData: false,        // обов'язково!
                    contentType: false,        // обов'язково!
                    timeout: 40000, // in milliseconds
                    success: (data) => {

                        data = JSON.parse(data);

                        // express
                        if (data.express_error!='') {
                            express.parents('.dropfile__container').parent().append(`<div class="alert mb0 mt4 alert-danger">${data.express_error}</div>`)
                        } else {
                            const file_express = B2B.base64ToFile(data.express, 'Експрес-накладна.pdf', 'application/pdf');
                            const dataTransfer = new DataTransfer();
                            dataTransfer.items.add(file_express);
                            express[0].files = dataTransfer.files;
                            express[0].dispatchEvent(new Event('change'));

                            const btn = express.parents('.dropfile__container').find('.js-dropfile__zoom');
                            btn.on('click', () => showPdfInPopup(file_express));
                            express.parents('.dropfile__container').addClass('dropfile__container-wide');
                        }

                        // zebra
                        if (data.express_error!='') {
                            zebra.parents('.dropfile__container').parent().append(`<div class="alert mb0 mt4 alert-danger">${data.zebra_error}</div>`)
                        } else {
                            const file_zebra = B2B.base64ToFile(data.zebra, 'Маркування.pdf', 'application/pdf');
                            const dataTransfer2 = new DataTransfer();
                            dataTransfer2.items.add(file_zebra);
                            zebra[0].files = dataTransfer2.files;
                            zebra[0].dispatchEvent(new Event('change'));

                            const btn2 = zebra.parents('.dropfile__container').find('.js-dropfile__zoom');
                            btn2.on('click', () => showPdfInPopup(file_zebra));
                            zebra.parents('.dropfile__container').addClass('dropfile__container-wide');
                        }

                    },
                    error: function(request, status, err) {

                    }
                });
            }).catch(() => {
                // console.log('key NOT exist');
            }).finally(() => {
                files.removeClass('loading');
            });

            return false;
        });

        jQuery("body").on("click", ".js-dropfile__remove", function (e) {
            e.preventDefault();
            const btn = $(this);
            btn.parents('.dropfile__container').find('input[type=file]').val('').trigger('change');
            btn.parents('.dropfile__container').find('label span').text('Оберіть файл');
        });

        if (document.location.pathname=='/u/settings') {
            B2B.novaposhtaGetApiKey().then(res => {
                $("[name=novaposhta_api_key]").val(res);
            }).catch(() => {
                // console.log('key NOT exist');
            });
        }

    });
}

init_B2B_events();